(() => {
  'use strict';

  function initMoreFilters() {
    const toggleBtn = document.querySelector('[data-more-filters-toggle]');
    const wrapper = document.querySelector('[data-more-filters-wrapper]');
    if (!toggleBtn || !wrapper) return;

    const textEl = toggleBtn.querySelector('[data-more-filters-text]');
    const countEl = toggleBtn.querySelector('[data-more-filters-count]');
    let isOpen = false;

    const activeCount = wrapper.querySelectorAll('.filter-group__item--active, .filter-group__pill--active').length;
    if (countEl && activeCount > 0) {
      countEl.textContent = activeCount;
    }

    if (activeCount > 0) {
      wrapper.classList.add('is-open');
      wrapper.style.display = '';
      isOpen = true;
      if (textEl) textEl.textContent = 'Fewer Filters';
    }

    toggleBtn.addEventListener('click', () => {
      isOpen = !isOpen;
      if (isOpen) {
        wrapper.classList.add('is-open');
        wrapper.style.display = '';
        if (textEl) textEl.textContent = 'Fewer Filters';
      } else {
        wrapper.classList.remove('is-open');
        wrapper.style.display = 'none';
        if (textEl) textEl.textContent = 'More Filters';
      }
    });
  }

  function initPriceButtons() {
    highlightActiveButton();
  }

  function highlightActiveButton() {
    const buttons = document.querySelectorAll('[data-price-filter-buttons] .filter-group__price-btn');
    if (!buttons.length) return;

    const params = new URLSearchParams(window.location.search);
    const urlMin = parseInt(params.get('filter.v.price.gte') || '', 10);
    const urlMax = parseInt(params.get('filter.v.price.lte') || '', 10);
    const hasMin = !Number.isNaN(urlMin);
    const hasMax = !Number.isNaN(urlMax);

    if (!hasMin && !hasMax) return;

    buttons.forEach((btn) => {
      const btnMin = parseInt(btn.getAttribute('data-price-min') || '', 10);
      const btnMax = parseInt(btn.getAttribute('data-price-max') || '', 10);
      const btnHasMax = btn.getAttribute('data-price-max') !== '';

      let match = false;
      if (btnHasMax) {
        match = hasMin && hasMax && Math.abs(urlMin - btnMin) <= 2 && Math.abs(urlMax - btnMax) <= 2;
      } else {
        match = hasMin && !hasMax && Math.abs(urlMin - btnMin) <= 2;
      }

      if (match) {
        btn.classList.add('is-active');
      }
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.filter-group__price-btn');
    if (!btn) return;

    const form = document.getElementById('CollectionFilterForm');
    if (!form) return;

    const minInput = form.querySelector('.cc-price-range__input--min');
    const maxInput = form.querySelector('.cc-price-range__input--max');
    if (!minInput || !maxInput) return;

    const min = btn.getAttribute('data-price-min') || '0';
    const max = btn.getAttribute('data-price-max') || '';

    minInput.value = min;
    maxInput.value = max;

    document.querySelectorAll('.filter-group__price-btn').forEach((b) => b.classList.remove('is-active'));
    btn.classList.add('is-active');

    minInput.dispatchEvent(new Event('change', { bubbles: true }));
    maxInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function init() {
    initMoreFilters();
    initPriceButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const filterContainer = document.querySelector('[data-ajax-container]');
  if (filterContainer) {
    const observer = new MutationObserver(() => {
      init();
    });
    observer.observe(filterContainer, { childList: true, subtree: true });
  }
})();
